import { is8DataApp } from '.';

export function getPublicFolderPath(urlPath: string) {
  let pathToPublicFolder = urlPath.split('/').map((item) => {
    return '../';
  });
  if (pathToPublicFolder.length >= 2) {
    pathToPublicFolder = pathToPublicFolder.slice(2);
  }
  return pathToPublicFolder.join('/');
}

export function getLogoSrc(theme: any, urlPath: string, cyanLogo = false) {
  const pathToPublicFolder = getPublicFolderPath(urlPath);
  const logo = cyanLogo ? 'logoCyan' : 'logo';
  let logoSrc = is8DataApp() ? theme['logoWhiteSmall'] : theme[logo];
  return pathToPublicFolder + logoSrc;
}
